import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ProfileActions from "../actions/ProfileActions";
import ProfileStore from "../stores/ProfileStore";
import Riskified from "arbitrip-common/client/utils/Riskified";

const NavigationTracker = () => {
    const location = useLocation();

    useEffect(() => {
        // Send navigation event to the backend
        ProfileActions.logNavigation(ProfileStore.getProfile());
        Riskified.trackPageview(location.pathname);
    }, [ location ]);

    return null; // This component does not render anything
};

export default NavigationTracker;